import { darken } from 'polished'
import { ThreeDots } from 'react-loader-spinner'
import styled, { css, useTheme } from 'styled-components'
import ripple from '../../styles/animations/ripple'

const LoadingComp: React.FunctionComponent = ({ color }: { color?: string }) => {
  const theme: any = useTheme()
  return (
    <ThreeDots
      wrapperStyle={{ justifyContent: 'center' }}
      color={color || theme.colors.primary}
      height={15}
    />
  )
}
export interface ButtonProps {
  $loading?: boolean
  $fullWidth?: boolean
  $color: string
  $variantType: 'block' | 'outline' | 'label' | 'small'
  children: any
}

export const Container = styled.button<ButtonProps>`
  -webkit-appearance: none;

  ${ripple};
  height: 100%;
  cursor: pointer;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 200ms linear, box-shadow 200ms linear, border-color 200ms linear;
  border-radius: 10px;
  ${({ $loading }) =>
    $loading &&
    css`
      cursor: not-allowed;
      pointer: normal;
      opacity: 60%;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      pointer: normal;
      opacity: 60%;
    `}

    
  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      width: 100%;
    `}  

    ${({ $color, $variantType, theme }) => {
    // Função auxiliar para acessar cores de forma segura
    const getColor = (colorKey: string) => {
      return (theme.colors as any)[colorKey] || theme.colors.primary;
    };

    if ($variantType === 'label') {
      return css`
        color: ${getColor($color)};
        background: transparent;
        display: flex;
        width: fit-content;
        height: 50px;
        align-items: center;

        &:not(:disabled):hover {
          color: ${darken(0.2, getColor($color))};
        }
      `
    }
    if ($variantType === 'outline') {
      return css`
        color: ${getColor($color)};
        background: transparent;
        height: 50px;
        border: 1.5px solid ${theme.colors.border};
        &:not(:disabled):hover {
          border-color: ${darken(0.2, theme.colors.border)};
          color: ${darken(0.2, getColor($color))};
        }
      `
    }

    if ($variantType === 'small') {
      return css`
        color: ${theme.colors.buttonLabel};
        background: ${getColor($color)};
        height: 40px;
        padding: 0px 15px;
        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
        &:not(:disabled):hover {
          background: ${darken(0.05, getColor($color))};
        }
      `
    }

    return css`
      color: ${theme.colors.buttonLabel};
      background: ${getColor($color)};
      height: 50px;
      padding: 0px 15px;
      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
      &:not(:disabled):hover {
        background: ${darken(0.05, getColor($color))};
      }
    `
  }}
`
export const Label = styled.div`
  font-size: 15px;
  font-weight: 800;
  line-height: 1;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
`

export const LoaderComponent = styled(LoadingComp)<any>`
  svg {
    margin: auto !important;
  }
`
